import { UtilsService } from 'app/shared/utils.service';
import { INSURANCE_APP_FRAMEWORKS } from './collection.constant';

//* This function generates the file name for the Beazley report based on the framework
export function getBeazleyReportFileName(frameworkName: string): string {
  //* in case framework is reassessed remove #
  const framework = UtilsService.extractFrameworkName(frameworkName);

  const fileNameMap: Record<string, string> = {
    [INSURANCE_APP_FRAMEWORKS.BEAZLEY]: 'Cyber Application.docx',
    [INSURANCE_APP_FRAMEWORKS.InsuranceWithOT]: 'Cyber Application with OT.docx',
    [INSURANCE_APP_FRAMEWORKS.BEAZLEY_TEO]: 'Cyber Application with Tech E&O.docx',
    [INSURANCE_APP_FRAMEWORKS.InsuranceWithOTAndTEO]: 'Cyber Application + OT + Tech E&O.docx',
  };

  return fileNameMap[framework] || 'Cyber Application.docx';
}
